import { PropsWithChildren, createContext, useContext, useState } from "react";

import { InsightsProperty } from "graphql-types/graphql";
import { ReductionProposal } from "legacyNext/types";

type StoreContext = {
    assetList: InsightsProperty[];
    setAssetList: (assetList: InsightsProperty[]) => void;
    proposals: Array<ReductionProposal>;
    setProposals: (proposals: Array<ReductionProposal>) => void;
};

const Store = createContext<StoreContext | undefined>(undefined);

export const LegacyNextStoreProvider = (props: PropsWithChildren) => {
    const { children } = props;

    const [assetList, setAssetList] = useState<InsightsProperty[]>([]);
    const [proposals, setProposals] = useState<ReductionProposal[]>([]);

    return (
        <Store.Provider
            value={{ proposals, setProposals, assetList, setAssetList }}
        >
            {children}
        </Store.Provider>
    );
};

export const useLegacyNextStore = () => {
    const context = useContext(Store);
    if (!context)
        throw new Error(
            "useLegacyNextStore must be used within a LegacyNextStoreProvider"
        );
    return context;
};
